import { render, staticRenderFns } from "./DenunciaTabelaInserirDados.vue?vue&type=template&id=024eb21e&lang=pug"
import script from "./DenunciaTabelaInserirDados.vue?vue&type=script&lang=js"
export * from "./DenunciaTabelaInserirDados.vue?vue&type=script&lang=js"
import style0 from "./DenunciaTabelaInserirDados.vue?vue&type=style&index=0&id=024eb21e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports